module.exports = __webpack_public_path__ + "img/tool1.c85d3806.png";